/* eslint-disable react/prop-types */ // TODO: add props
import { useMemo } from 'react';
import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import EPT from 'edrolo/propTypes';
import { ResultsTable, leftSpacer, rightSpacer } from '../../../components';
import { StudentResponseBars } from '../StudentResponseBars';
import {
  StackedBarChartMultiChoice,
  StackedBarChartMultiSelect,
} from '../StackedBarChart';
import { getProfileQuestionResponseSummary } from '../../../utils';
import style from './styles.scss';

export const CorrectableQuestionReview = ({
  question,
  solution,
  responses,
  classStudentProfiles,
  highlightProfileId,
  nameColumn,
  studentResponseColumnSpec,
  expanderColumn = { id: 'expander', style: { width: '0%' } },
  answeredCorrectlyColumn = { id: 'answeredCorrectly', style: { width: '0%' } },
  showChart = false,
  checklist = false,
  showCorrectness = false,
  isMultiChoiceMultiAnswer = false,
}) => {
  const profileQuestionResponseSummary = useMemo(
    () =>
      getProfileQuestionResponseSummary(
        classStudentProfiles,
        responses,
        solution
      ),
    [classStudentProfiles, responses, solution]
  );

  const questionType = question && question.get('question_type');

  const resultsTableColumns = [
    leftSpacer,
    nameColumn,
    studentResponseColumnSpec,
    answeredCorrectlyColumn,
    expanderColumn,
    rightSpacer,
  ];

  const table = (
    <div>
      <h3 className={style.heading}>Response details</h3>
      <ResultsTable
        data={profileQuestionResponseSummary}
        columns={resultsTableColumns}
        highlightProfileId={highlightProfileId}
      />
    </div>
  );

  return (
    <>
      <div className={style.container}>
        <div className={style.responseBars}>
          <h3 className={style.heading}>How students responded</h3>
          <StudentResponseBars
            profileQuestionResponseSummary={profileQuestionResponseSummary}
            questionType={questionType}
            showCorrectness={showCorrectness}
          />
        </div>

        {showChart && !checklist && (
          <div className={style.chartContainer}>
            <h3 className={style.heading}>Multiple choice responses</h3>
            {isMultiChoiceMultiAnswer ? (
              <StackedBarChartMultiSelect
                question={question}
                solution={solution}
                profileQuestionResponseSummary={profileQuestionResponseSummary}
              />
            ) : (
              <StackedBarChartMultiChoice
                question={question}
                solution={solution}
                profileQuestionResponseSummary={profileQuestionResponseSummary}
              />
            )}
          </div>
        )}
        {!showChart && table}
      </div>
      {showChart && table}
    </>
  );
};

export const correctableQuestionPropTypes = {
  question: EPT.ExamQuestion.isRequired,
  solution: IPT.contains({
    solution: IPT.contains({
      exemplar_response_checklist_items: IPT.listOf(
        IPT.contains({
          id: PT.number.isRequired,
          description: PT.string.isRequired,
        })
      ),
    }),
  }).isRequired,
  responses: IPT.listOf(EPT.ExamResponse),
  classStudentProfiles: IPT.orderedMapOf(
    IPT.contains({
      user_id: PT.number.isRequired,
      profile_id: PT.number.isRequired,
      first_name: PT.string.isRequired,
      last_name: PT.string.isRequired,
      display_name: PT.string,
      is_active: PT.bool,
    })
  ),
  highlightProfileId: PT.number,
  isMultiChoiceMultiAnswer: PT.bool,
};

CorrectableQuestionReview.propTypes = correctableQuestionPropTypes;
